<template>
    <registration-form>
        <email-input name="email" :placeholder="emailPlaceholder" :input-error="emailInputError">{{ emailLabel }}</email-input>
        <permission-section
            :permission-label="permissionLabel"
            :permission-terms="permissionTerms"
            :permission-terms-headline="permissionTermsHeadline"
            :permission-brand="permissionBrand"
            :permission-config="permissions"
            :newsletter-config="newsletters"
            :input-error="permissionInputError">
            <button type="submit" slot="afterCheckbox" class="btn newsletter__btn newsletter__btn_subscribe">{{ submitLabel }}</button>
        </permission-section>
    </registration-form>
</template>

<script>
import RegistrationForm from '../components/RegistrationForm.vue'
import EmailInput from '../components/EmailInput.vue'
import PermissionSection from '../components/PermissionSection.vue'

export default {
    name: 'FormView',
    components: [
        RegistrationForm,
        EmailInput,
        PermissionSection
    ],
    data() {
        return {
            emailLabel: this.$root.config.emailInput.label,
            emailPlaceholder: this.$root.config.emailInput.placeholder,
            emailInputError: this.$root.config.emailInput.inputError,

            submitLabel: this.$root.config.submitButton.label,

            permissionLabel: this.$root.config.permissionSection.label,
            permissionTermsHeadline: this.$root.config.permissionSection.termsHeadline,
            permissionTerms: this.$root.config.permissionSection.terms,
            permissionBrand: this.$root.config.permissionSection.brand,
            permissionInputError: this.$root.config.permissionSection.inputError,

            permissions: this.$root.config.permissionSection.permissions,
            newsletters: this.$root.config.permissionSection.newsletters,
        }
    }
}
</script>


// WEBPACK FOOTER //
// FormView.vue?1c623318